import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserByType, getUserCount } from "../../slices/UserSlice";
import { CountTiles } from "./components/count-tiles";
import { Maps } from "./components/maps";
import SelectBox from "../../components/admin/SelectBox";
import { CityByState, cityPincode, getAllState } from "../../slices/InitialDataSlice";
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import defaultConfig from "../../config/Config";

export function Dashboard() {
  const [userCnt, setUserCnt] = useState([])
  const dispatch = useDispatch();
  const { dashboardDataUserCount: userCount, usersByType} = useSelector((state) => state.users)
  const { 
    StateList: stateListData, 
    CitiesList: cityListData, 
    pincodeList: pincodeListData 
  } = useSelector((state) => state.initialData) 
  const [citiesList, setCitiesList] = useState([])
  const [stateList, setStateList] = useState([])
  const [pincodeList, setPincodeList] = useState([])
  const [levelToShowSelect, setLevelToShowSelect] = useState(0)
  const [selectedUserTypes, setSelectedUserTypes] = useState('')
  const [userTypes, setUserTypes] = useState([])
  const [userLatLangList, setUserLatLangList] = useState([])
  const [selectedValues, setSelectedValues] = useState({})
  useEffect(() => {
    dispatch( getUserCount() )
    dispatch(getAllState())
    setUserTypes(ToSelectOption(defaultConfig.dashboardUserType, { value:"value", label:"label" }))
  }, [dispatch]) 

  useEffect( () => {
    setUserCnt(userCount)
    let list = []
    if(stateListData){
      stateListData?.forEach(item => {
        if(item._id !== ""){
          list.push({
            value : item._id,
            label: item.name
          })
        }
      })
      setStateList(list)
    }
    
    if( cityListData){
      const list = cityListData.map((item) => {
          return {
              label: item.name,
              value: item._id
          }
      })
      setCitiesList(list)
    }
    
    if( pincodeListData){
      const list = pincodeListData.map((item) => {
          return {
              label: item.pincode,
              value: item._id
          }
      })
      setPincodeList(list)
    }

  }, [cityListData, pincodeListData, stateListData, userCount])

  useEffect( () => {
    
    let list = []
    if(typeof usersByType !== "undefined"){
      list = usersByType?.map( ({userDetails}) => {
        return {
            ...userDetails
        }
      })
    }
    setUserLatLangList(list)
  }, [usersByType])

  const onChange = (opt, type)=>{
    setUserLatLangList([]);
    let key = ''
    if(type === 'state') {
      key = 'stateId';
      setSelectedValues({})
      if(opt?.value){
        dispatch(CityByState(opt?.value))
      }
      
    }else if( type === 'city') {
      key = 'cityId';
      setSelectedValues({...selectedValues, cityId: '', pincode: ''})
      if(opt?.value) {
        dispatch(cityPincode({cityId: opt?.value, extraQueryStr:{groupByPincode: true}}))
      } 
      
    }else if(type === 'pincode') {
      key = 'pincode';
    }
    setSelectedValues({...selectedValues, [key]: opt?.value})
    if(opt?.value && selectedUserTypes){
      dispatch(getUserByType({userType: selectedUserTypes, [key]: opt?.value}))
    }
    
    
  }

  const onUserTypeChange = (opt)=>{
    setUserLatLangList([]) 
    if(opt?.value === 'csa') {
      setLevelToShowSelect(1)
    }else if(opt?.value === 'superStockists' || opt?.value === 'distributors') {
      setLevelToShowSelect(2)
    }else if(opt?.value === 'retailers') {
      setLevelToShowSelect(3)
    }
    setSelectedValues({stateId:'', cityId: '', pincode: ''})
    setSelectedUserTypes(opt?.value)
  }

  return (
    <React.Fragment>
      <div className="col-sm-10 col-xl-12">
        <div className="row earning_data">
          <>
          {
            userCnt? userCnt?.map((user, index) => {
                return <CountTiles key={index} {...user} />
            }):''
          }
          </>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-3">
            <div className={`form-group mb-4`}>
                <label className={`d-block`} htmlFor="State">User Type</label>
                <SelectBox
                    options={userTypes}
                    isClearable={true}
                    onChange={(opt) => onUserTypeChange(opt)}
                    value={userTypes.find(
                        (option) => option.value === selectedUserTypes
                    ) || ''}
                />                      
            </div>
          </div>
          <div className="col-md-3">
            <div className={`form-group mb-4 ${ levelToShowSelect < 1? 'hide' : ''  }`}>
                <label className={`d-block`} htmlFor="State">State</label>
                <SelectBox
                    options={stateList}
                    isClearable={true}
                    onChange={(opt) => onChange(opt, 'state')}
                    value={stateList.find(
                        (option) => option.value === selectedValues['stateId']
                    ) || ''}
                />
            </div>
          </div>
          <div className="col-md-3">
            <div className={`form-group mb-4 ${ levelToShowSelect < 2? 'hide' : ''  }`}>
                <label className={`d-block`} htmlFor="State">City</label>
                <SelectBox
                            options={citiesList}
                            isClearable={true}
                            onChange={(opt) => onChange(opt, 'city')}
                            value={citiesList.find(
                                (option) => option.value == selectedValues['cityId']
                            ) || ''}
                        />
            </div>
          </div>
          <div className="col-md-3">
            <div className={`form-group mb-4 ${ levelToShowSelect < 3? 'hide' : ''  }`}>
                <label className={`d-block`} htmlFor="State">Pincode</label>
                <SelectBox
                            options={pincodeList}
                            isClearable={true}
                            onChange={(opt) => onChange(opt, 'pincode')}
                            value={pincodeList.find(
                              (option) => option.value == selectedValues['pincode']
                            ) || ''}
                        />
            </div>
          </div>
        </div>
        {selectedUserTypes?<div className="col-sm-12 pl-0">
          <label>Total Number Of {userTypes.find( (item) => item.value === selectedUserTypes )?.label } : <strong>{ userLatLangList? userLatLangList.length: 0 }</strong></label>
        </div>:''}
        <div className="col-sm-12">
          <Maps data={ {userLatLangList} }></Maps>
        </div>
        
      </div>
      
    </React.Fragment>
  );
}
